import type { TripViewModel } from 'flights/tripViewModel';

import type { FlightSearchResultLeg } from '@wegoTypes/flights/metasearch/flightSearchResultLeg';

export function isTripViewModelWithinSelectedTimeBlocksFilter(
  tripViewModel: TripViewModel,
  selectedTimeBlocks: Array<FlightMulticityFilterState<FlightFilterTimeBlock>>,
  legAndTime: FlightLegAndTime,
): boolean {
  const flightTimeFilterValuesForEachLeg = selectedTimeBlocks.map((selectedTimeBlock) => {
    if (selectedTimeBlock.values.length > 0) {
      let legIndex = selectedTimeBlock.leg;

      if (legAndTime === 'returnLegArrivalTime' || legAndTime === 'returnLegDepartureTime') {
        legIndex = 1;
      }

      const flightTimeFilterValuePerLeg = selectedTimeBlock.values.map((value) => {
        return isFlightTimeWithinSelectedTimeBlock(
          getDepartureOrArrivalTimeForFiltering(tripViewModel.legs[legIndex].leg, legAndTime),
          value,
        );
      });

      return flightTimeFilterValuePerLeg.some(Boolean);
    }

    return true;
  });

  return flightTimeFilterValuesForEachLeg.every(Boolean);
}

export function getDepartureOrArrivalTimeForFiltering(
  leg: FlightSearchResultLeg,
  legAndTime: FlightLegAndTime,
): number {
  switch (legAndTime) {
    case 'departLegDepartureTime':
    case 'returnLegDepartureTime':
      return leg.departureTimeMinutes;

    case 'departLegArrivalTime':
    case 'returnLegArrivalTime':
      return leg.arrivalTimeMinutes;
  }
}

export function isFlightTimeWithinSelectedTimeBlock(
  flightTimeMinutes: number,
  timeBlock: FlightFilterTimeBlock,
): boolean {
  switch (timeBlock) {
    case '0000-0600':
      return 0 <= flightTimeMinutes && flightTimeMinutes <= 360;
    case '0600-1200':
      return 360 <= flightTimeMinutes && flightTimeMinutes <= 720;
    case '1200-1800':
      return 720 <= flightTimeMinutes && flightTimeMinutes <= 1080;
    case '1800-2400':
      return (1080 <= flightTimeMinutes && flightTimeMinutes <= 1440) || flightTimeMinutes === 0;
  }
}

export const matchFareFilterCriteria = (
  provider: FlightSearchResultProvider,
  selectedFareProviderCodes: Array<string>,
  isBookOnWego: boolean,
  isBookWithAirlines: boolean,
): boolean => {
  let matchesProvidersFilter = true;
  let matchesProviderCodesFilter = true;

  if (selectedFareProviderCodes.length > 0 || isBookOnWego || isBookWithAirlines) {
    // Match by providers
    if (isBookOnWego && isBookWithAirlines) {
      matchesProvidersFilter = provider?.wegoFare || provider?.type === 'airline';
    } else if (isBookOnWego) {
      matchesProvidersFilter = provider?.wegoFare;
    } else if (isBookWithAirlines) {
      matchesProvidersFilter = provider?.type === 'airline';
    }

    // Match by provider codes
    if (selectedFareProviderCodes.length > 0) {
      matchesProviderCodesFilter = selectedFareProviderCodes.includes(provider?.code);
    }
  }
  return matchesProvidersFilter && matchesProviderCodesFilter;
};

export function checkIfTripViewModelContainsSelectedLegs(
  tripViewModel: TripViewModel,
  selectedLegs: Array<{ index: number; legId: string }>,
): boolean {
  let hasSelectedLegs = true;
  selectedLegs.forEach((selectedLeg) => {
    hasSelectedLegs =
      hasSelectedLegs && tripViewModel.legs[selectedLeg.index].leg.id === selectedLeg.legId;
  });

  return hasSelectedLegs;
}
